import Rx from 'rxjs';
import moment from 'moment';
import { goBack } from 'react-router-redux';
import { combineEpics } from 'redux-observable';

import { dias } from 'core/constants';
import * as constAction from 'root/actionConstants';
import * as viajesActions from 'modules/viajes/action';
import * as rutinasActions from 'modules/rutinas/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$.ofType(constAction.RUTINAS_GET_BY_ID).switchMap(action =>
    ajax(request(action))
      .map(result => rutinasActions.setState({ rutina: result.response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getByIdEpic = (action$, store) =>
  action$.ofType(constAction.RUTINAS_GET).switchMap(action =>
    ajax(request(action))
      .map(result => rutinasActions.setState({ lista: result.response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.RUTINAS_SET)
    .throttleTime(2000)
    .switchMap(action => {
      return ajax(request(action))
        .switchMap(() => Rx.Observable.merge(Rx.Observable.of(rutinasActions.get()), Rx.Observable.of(goBack()), Rx.Observable.of(generalActions.snackbar_show('Rutina guardada'))))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide()));
    });

export const deleteEpic = (action$, store) =>
  action$
    .ofType(constAction.RUTINAS_DELETE)
    .throttleTime(500)
    .switchMap(action =>
      ajax(request(action))
        .mapTo(generalActions.snackbar_show('Rutina eliminada'))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const setGruposAViajesEpic = (action$, store) =>
  action$.ofType(constAction.RUTINAS_SET_GRUPOS_A_VIAJES).switchMap(action =>
    ajax(request(action))
      .mapTo(generalActions.snackbar_show('Grupos aplicados a todos los viajes de esta rutina'))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setCambiosAViajesEpic = (action$, store) =>
  action$.ofType(constAction.RUTINAS_SET_CAMBIOS_A_VIAJES).switchMap(action =>
    ajax(request(action))
      .mapTo(generalActions.snackbar_show('Cambios aplicados a todos los viajes de esta rutina'))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

//-- EPICS DE OTROS COMPONENTES --//
export const getParadasEpic = (action$, store) =>
  action$
    .ofType(constAction.RUTINAS_PARADAS_GET)
    .throttleTime(1000)
    .switchMap(action =>
      ajax(request(action))
        .map(result => rutinasActions.setState({ paradas: result.response }))
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(getEpic, setEpic, deleteEpic, getByIdEpic, getParadasEpic, setGruposAViajesEpic, setCambiosAViajesEpic);



// WEBPACK FOOTER //
// src/modules/rutinas/epics.js